
import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { NavService, Menu } from '../../services/nav.service';
import { AuthService } from '../../services/firebase/auth.service';
import { SearchService } from '../../services/search.service';
import { Router } from '@angular/router';
import { NetsolinApp } from '../../global';

var body = document.getElementsByTagName("body")[0];

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

  public menuItems: Menu[];
  public items: Menu[];
  public openNav: boolean = false
  public right_sidebar: boolean = false
  public text: string
  public search="";
  public open=false;
  public results=[]
  public nom_empresa='';
  public nomusuar='';
  public icons={
    vehiculo:"car-wheel-2",
    bp:"apartment"
  }

  @Output() rightSidebarEvent = new EventEmitter<boolean>();


  constructor(private router: Router, public navServices: NavService, public authService: AuthService,private searchS: SearchService) { }

  ngOnInit() {
    this.navServices.items.subscribe(menuItems => {
      this.items = menuItems
      // console.log('header this.navServices:',this.navServices,NetsolinApp);
      this.nom_empresa = NetsolinApp.oapp.nom_empresa;
      this.nomusuar = NetsolinApp.oapp.nomusuar;
    });
  }

  collapseSidebar() {
    this.navServices.collapseSidebar = !this.navServices.collapseSidebar
  }

  collapseUserSidebar() {
    this.navServices.collapseUserSidebar = !this.navServices.collapseUserSidebar
    document.getElementsByTagName("html")[0].classList.toggle("less")
    console.log(document.getElementsByTagName("html")[0]);
  }

  reSearch() {
    if(this.search.length>2){
      let results = this.searchS.search(this.search);
      console.log(this.search,results)
      this.results=results;
      this.open=true;
    }
    else{
      this.open=false
    }
  }
  goTo(ele){
    this.open=false;
    this.search="";
    console.log(ele, `/up/${ele.data.up ? ele.data.up : ele.data.unidadPrivada}`);
    this.router.navigate([`/up/${ele.data.up ? ele.data.up : ele.data.unidadPrivada}`]);

  }
}
